import script from "./LotePestanias.vue?vue&type=script&setup=true&lang=js"
export * from "./LotePestanias.vue?vue&type=script&setup=true&lang=js"

import "./LotePestanias.vue?vue&type=style&index=0&id=7de30bdc&lang=css"

const __exports__ = script;

export default __exports__